import { Component } from '@angular/core';
import { MediaPanelInfo } from '../../../../../models/datamodel/mediasource.model';
import { SettingsService } from '../../../../../services/settings.service';
import { BaseMediaSourcePanel } from '../basemediasource.panel';

@Component({
    selector: 'box-panel',
    templateUrl: './box.panel.html',
    styleUrls: ['./box.panel.css']
})
export class BoxPanel extends BaseMediaSourcePanel {

    get RedirectUrl(): string {
        const ret = SettingsService.API_BASE_URL.getValue() + 'config/api/media/oauth/authorizebox';
        this.MediaSource.RedirectUrl = ret;
        this.MediaSource.Private = true; 
        return ret;
    }

    set RedirectUrl(val) {
        if (val != this.MediaSource.RedirectUrl) {
            this.MediaSource.RedirectUrl = val;
        }
    }

    authenticate(): void {
        const authstring = 'https://account.box.com/api/oauth2/authorize?response_type=code&state=' + this.MediaSource.SID + '&redirect_uri=' + this.MediaSource.RedirectUrl + '&client_id=' + this.MediaSource.ClientId;
        window.open(authstring, '_blank');
    }

    static GetInfo(): MediaPanelInfo {
        return { 
            ControlType: BoxPanel,
            MediaType: '42b0d605-aee4-483c-aa56-9d650986a797'
        };
    }
}
